<template>
  <div>
    <!-- 菜单 -->
    <el-col
      v-if="topButtonList != null && topButtonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-input
            placeholder="公司/姓名/手机/职位"
            v-model="filters.SearchKey"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="课程介绍"
            v-model="filters.CourseDesc"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.GoodAt" placeholder="擅长领域" clearable>
            <el-option
              v-for="item in goodatList"
              :label="item.Name"
              :value="item.Name"
              :key="item.Name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="formDate"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="合同开始日期"
            end-placeholder="合同结束日期"
            @change="selectTime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-for="item in topButtonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!-- 数据列表 -->
    <el-table
      border=""
      :data="tabData"
      v-loading="listLoading"
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        prop="CompanyName"
        label="公司名称"
        width=""
      ></el-table-column>
      <el-table-column prop="Name" label="姓名" width="150"></el-table-column>
      <el-table-column
        prop="PhoneNumber"
        label="手机号码"
        width="110"
      ></el-table-column>
      <el-table-column
        prop="Position"
        label="职位"
        width="240"
      ></el-table-column>
      <el-table-column
        prop="UserName"
        label="对接人"
        width="80"
      ></el-table-column>
      <el-table-column prop="" label="合同" width="150"></el-table-column>
      <el-table-column
        label="操作"
        width="120"
        v-if="tableButtonList.length > 0"
      >
        <template slot-scope="scope">
          <span
            v-for="item in tableButtonList"
            :key="item.id"
            style="padding-left: 10px"
          >
            <el-button
              type="text"
              v-bind:key="item.id"
              v-prevent-re-click
              v-if="!item.IsHide"
              @click="callFunc(item, scope.row)"
              >{{ item.name }}</el-button
            >
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-pagination
      layout="total, prev, pager, next"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="filters.PageIndex"
      :page-size="filters.PageSize"
      :total="filters.total"
      style="float: right"
    ></el-pagination>

    <!-- 新增弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="70%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="insertForm"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="Picture" label="讲师照片">
              <div style="display: block">
                <div v-if="ruleForm.Picture">
                  <img
                    class="picImg"
                    :src="
                      ruleForm.Picture +
                      '?x-oss-process=image/resize,h_500,w_500,m_fixed'
                    "
                  />
                </div>
                <div class="divUpload">
                  <UploadPan
                    ref="upload"
                    v-model="fileList"
                    :form="form"
                    class="editor-upload-btn"
                    :model="model"
                    @on-close="handleCloseUpload"
                    @on-update="handleOnUpdate"
                    :accept="accept"
                    color="#1890ff"
                  />
                  <span style="font-size: 12px"
                    >宽500（像素）*高500（像素）</span
                  >
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="Name">
              <el-input
                v-model="ruleForm.Name"
                placeholder="讲师姓名"
                maxlength="100"
              ></el-input>
            </el-form-item>
            <el-form-item prop="CompanyName">
              <el-input
                v-model="ruleForm.CompanyName"
                placeholder="讲师公司名称"
                maxlength="100"
              ></el-input>
            </el-form-item>
            <el-form-item prop="PhoneNumber">
              <el-input
                v-model="ruleForm.PhoneNumber"
                placeholder="讲师手机"
                maxlength="11"
              ></el-input>
            </el-form-item>
            <el-form-item prop="Email">
              <el-input
                v-model="ruleForm.Email"
                placeholder="讲师邮箱"
                maxlength="100"
              ></el-input>
            </el-form-item>
            <el-form-item prop="Position">
              <el-input
                v-model="ruleForm.Position"
                placeholder="讲师职位"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="GoodAts">
              <el-select
                v-model="ruleForm.GoodAts"
                placeholder="讲师擅长领域"
                multiple
                @change="goodAtChange"
              >
                <el-option
                  v-for="item in goodatList"
                  :label="item.Name"
                  :value="item.Name"
                  :key="item.Name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="UserName">
              <el-select
                v-model="ruleForm.UserName"
                placeholder="讲师对接人"
                @change="ChangUserId"
              >
                <el-option
                  v-for="item in userNameList"
                  :label="item.LoginName"
                  :value="item.LoginName"
                  :key="item.UserId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="cascaderCity" class="is-required">
              <el-cascader
                size="large"
                :options="options"
                clearable
                placeholder="请选择讲师所在城市"
                v-model="cascaderCity"
                :props="{ checkStrictly: true, expandTrigger: 'hover' }"
                @change="handleCityChange"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item prop="IsOnline">
              <el-select v-model="ruleForm.IsOnline" placeholder="是否线上授课">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="WeiXinId">
              <el-input
                v-model="ruleForm.WeiXinId"
                placeholder="讲师微信号"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="divFlex">
          <div class="left">讲师介绍：</div>
          <div class="right">
            <el-form-item prop="Desc">
              <Tinymce
                ref="descTinymce"
                v-model="ruleForm.Desc"
                :accept="accept"
                :form="form"
                :model="model"
              ></Tinymce>
            </el-form-item>
          </div>
        </div>
        <div class="divFlex">
          <div class="left">课程介绍：</div>
          <div class="right">
            <el-form-item prop="CourseDesc">
              <Tinymce
                ref="CourseDescTinymce"
                v-model="ruleForm.CourseDesc"
                :accept="accept"
                :form="form"
                :model="model"
              ></Tinymce>
            </el-form-item>
          </div>
        </div>
        <el-form-item class="submitBtn">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import UploadPan from '@/components/Upload/index'
import Tinymce from '@/components/Tinymce/index'
import { getButtonList } from '../../promissionRouter'
import { codeToText, provinceAndCityData } from 'element-china-area-data'
import {
  getLecturerList,
  AddOrUpdLecturer,
  getLecturerInfo,
  getGoodatList,
  getUserName,
} from '../../api/api'
import store from '@/store'

export default {
  data() {
    return {
      options: provinceAndCityData, // 城市联动数据
      cascaderCity: [], // 城市
      topButtonList: [],
      tableButtonList: [],
      formDate: [], // 合同时间
      goodatList: [], // 擅长领域
      userNameList: [], // 对接人
      tabData: [], // 数据
      listLoading: false, //数据加载效果
      filters: {
        SearchKey: '', // 关键字
        CourseDesc: '', // 课程介绍
        GoodAt: '', // 擅长领域
        StartTime: '',
        EndTime: '',
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      dialogVisible: false, // 弹窗
      dialogTitle: '', // 弹窗标题
      ruleForm: {
        Picture: '',
        Name: '',
        CompanyName: '',
        PhoneNumber: '',
        Position: '',
        Email: '',
        GoodAt: '',
        GoodAts: [],
        UserName: '',
        UserId: 0,
        Province: '', // 省份
        CityCode: '', // 城市 编码
        CityName: '', // 城市 中文名字
        IsOnline: '',
        Desc: '',
        CourseDesc: '',
        WeiXinId: '',
      },
      rules: {
        Picture: [
          {
            required: true,
            message: '请上传讲师照片',
            trigger: ['blur', 'change'],
          },
        ],
        Name: [{ required: true, message: '请输入讲师姓名', trigger: 'blur' }],
        CompanyName: [
          { required: true, message: '请输入讲师公司名称', trigger: 'blur' },
        ],
        PhoneNumber: [
          { required: true, message: '请输入讲师手机', trigger: 'blur' },
          {
            pattern: /^1\d{10}$/,
            message: '请输入正确的手机号',
          },
        ],
        Email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱',
            trigger: ['blur', 'change'],
          },
        ],
        Position: [
          { required: true, message: '请输入讲师职位', trigger: 'blur' },
        ],
        GoodAts: [
          { required: true, message: '请选择讲师擅长领域', trigger: 'change' },
        ],
        UserName: [
          { required: true, message: '请选择讲师对接人', trigger: 'change' },
        ],
        CityCode: [
          { required: true, message: '请选择讲师所在城市', trigger: 'change' },
        ],
        IsOnline: [
          { required: true, message: '请选择是否线上授课', trigger: 'change' },
        ],
        Desc: [{ required: true, message: '请输入讲师介绍', trigger: 'blur' }],
        CourseDesc: [
          { required: true, message: '请输入课程介绍', trigger: 'blur' },
        ],
      },
      fileList: [],
      model: `hrmarket/${new Date().getFullYear()}${new Date().getMonth() + 1}`,
      form: {
        bucket: 'video-hroot',
        region: 'oss-cn-hangzhou',
      },
      accept: '.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PBG,.GIF',
    }
  },
  components: {
    UploadPan,
    Tinymce,
  },
  methods: {
    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    },

    // 查询
    handleQuery() {
      this.listLoading = true
      getLecturerList(this.filters).then((res) => {
        // console.log(res)
        if (res.data.success) {
          this.tabData = res.data.response.data
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.listLoading = false
        }
      })
    },

    // 选择合同时间
    selectTime(val) {
      if (val) {
        this.filters.StartTime = this.formDate[0]
        this.filters.EndTime = this.formDate[1]
      } else {
        this.filters.StartTime = this.filters.EndTime = ''
      }
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '新增讲师'
      this.dialogVisible = true
      this.initTinymce()
      console.log(this.ruleForm)
    },

    //  编辑
    handleUpdate() {
      getLecturerInfo(this.currentRow.Id).then((res) => {
        if (res.data.success) {
          this.dialogTitle = '编辑讲师'
          this.dialogVisible = true
          this.$nextTick(() => {
            this.ruleForm = res.data.response
            this.ruleForm.GoodAts = this.ruleForm.GoodAt.split(',')
            this.cascaderCity = res.data.response.CityCode
            this.initTinymce()
          })
        }
      })
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!this.ruleForm.CityCode) {
          this.$message({
            message: '请选择讲师所在城市',
            type: 'error',
          })
          return false
        }

        if (valid) {
          console.log('------------this.ruleForm------------')
          console.log(this.ruleForm)
          AddOrUpdLecturer(this.ruleForm).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.$refs[formName].resetFields()
              this.dialogVisible = false
              this.cascaderCity = []
              this.handleQuery()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 详情
    handleInfo() {
      store.commit('saveLecturerId', this.currentRow.Id)
      this.$router.push(`/Lecturer/LecturerInfo`)
    },

    handleCloseUpload() {
      this.fileList = []
    },
    handleOnUpdate(obj) {
      console.log('handleOnUpdate')
      console.log(obj)

      // ?x-oss-process=image/resize,h_500,w_500,m_fixed
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      this.ruleForm.Picture = url
    },
    // 弹窗关闭
    handleClose() {
      this.ruleForm.GoodAt = ''
      this.dialogVisible = false
      this.cascaderCity = []
      this.$refs.ruleForm.resetFields()
    },

    // 切换城市联动
    handleCityChange(value) {
      console.log(value)
      if (this.cascaderCity.length > 1) {
        this.ruleForm.Province = this.cascaderCity[0]
        this.ruleForm.CityCode = this.cascaderCity[1]
        this.ruleForm.CityName = codeToText[this.cascaderCity[1]]
      } else {
        this.ruleForm.CityCode = this.cascaderCity[0]
        this.ruleForm.CityName = codeToText[this.cascaderCity[0]]
      }
      console.log(this.ruleForm.CityCode)
      console.log(this.ruleForm.CityName)
    },

    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 擅长领域
    queryGoodatList() {
      getGoodatList().then((res) => {
        if (res.data.success) {
          this.goodatList = res.data.response
        }
      })
    },
    // 对接人
    queryUserNameList() {
      getUserName().then((res) => {
        if (res.data.success) {
          this.userNameList = res.data.response
        }
      })
    },
    ChangUserId(val) {
      this.ruleForm.UserId = val
        ? this.userNameList.find((ele) => ele.LoginName === val).UserId
        : ''
      console.log('val: ' + val)
    },
    goodAtChange() {
      this.ruleForm.GoodAt = this.ruleForm.GoodAts.join(',')
      this.$forceUpdate()
    },
    initTinymce() {
      this.$refs.descTinymce.setContent(this.ruleForm.Desc)
      this.$refs.CourseDescTinymce.setContent(this.ruleForm.CourseDesc)
    },
  },
  mounted() {
    this.handleQuery()
    this.queryGoodatList()
    this.queryUserNameList()

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.topButtonList = buttonList.filter((item) => {
      return item.ButtonType === 0
    })
    this.tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 1
    })
  },
}
</script>

<style scoped>
.divUpload {
  text-align: center;
  padding-left: 60px;
}
.submitBtn {
  text-align: center;
}
.divFlex {
  display: flex;
  flex-wrap: nowrap;
}
.divFlex .left {
  width: 110px;
}
.divFlex .right {
  flex: 1;
}
img.picImg {
  width: 150px;
}
.insertForm .el-select,
.insertForm .el-cascader {
  width: 100%;
}
</style>
